// NG 2
import { Injectable, OnInit } from '@angular/core';
import { Http, Response, } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

// APP
import { AppConfig } from '../app.config';
import { ProgressService } from './progress.service';
import { BaseService } from './base.service';

@Injectable()
export class InformationService extends BaseService {
    

    _baseUrl: string = AppConfig.config.defaultServicePath + 'MIHInformation/';   
    constructor(private http: Http
        , private progressService: ProgressService) {
        super();
    }

    saveMIHArea(MihArea) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'SaveMIHArea', MihArea, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    SaveConstruction(construction) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'SaveConstruction', construction, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    SaveAHF(AHF) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'SaveAHF', AHF, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    getQuestionByType(projectId, type) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetTrackings?projectId=' + projectId + '&type=' + type, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
           .finally(() => this.progressService.remove())           
    }


    SaveUnitCount(unitCount) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'SaveUnitCount', unitCount, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    SaveProjectBuildingFloorAreaUnitCount(unitCount) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'SaveProjectBuildingFloorAreaUnitCount', unitCount, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    GetProjectBuildingFloorAreaUnitCount(projectBuildingId, siteProjBuildingId) {
        this.progressService.add();
        var ProjectBuildingId = projectBuildingId;
        return this.http.get(this._baseUrl + 'GetProjectBuildingFloorAreaUnitCount?DevProjectBuildingId=' + projectBuildingId + '&SiteProjectBuildingId=' + siteProjBuildingId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    SaveProjectBuildingPublicFunding(publicFunding) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'SaveProjectBuildingPublicFunding', publicFunding, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    GetProjectBuildingPublicFunding(devProjectBuildingId, siteProjBuildingId) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetProjectBuildingPublicFunding?DevProjectBuildingId=' + devProjectBuildingId + '&SiteProjectBuildingId=' + siteProjBuildingId, this.addHeader())       
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    
    SaveProjectBuildingMIHOption(mihoptions) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'SaveProjectBuildingMIHOption', mihoptions, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    GetProjectBuildingMIHOption(devProjectBuildingId, siteProjBuildingId) {
        this.progressService.add();        
        return this.http.get(this._baseUrl + 'GetProjectBuildingMIHOption?DevProjectBuildingId=' + devProjectBuildingId + '&SiteProjectBuildingId=' + siteProjBuildingId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    SaveProjectBuildingLocationOfMIHUnits(mihunits) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'SaveProjectBuildingLocationOfMIHUnits', mihunits, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }  

    GetProjectBuildingLocationOfMIHUnits(devProjectBuildingId, siteProjBuildingId) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetProjectBuildingLocationOfMIHUnits?DevProjectBuildingId=' + devProjectBuildingId + '&SiteProjectBuildingId=' + siteProjBuildingId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    } 



    GetProjectBuildingSiteLocation(devProjectBuildingId, siteProjBuildingId) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetProjectBuildingSiteLocation?DevProjectBuildingId=' + devProjectBuildingId + '&SiteProjectBuildingId=' + siteProjBuildingId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    SaveProjectBuildingSiteLocation(sitelocation) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'SaveProjectBuildingSiteLocation', sitelocation, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    SaveProjectBuildingTaxCredits(siteTaxCredit) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'SaveProjectBuildingTaxCredits', siteTaxCredit, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    
    GetProjectBuildingTaxCredits(devProjectBuildingId, siteProjBuildingId) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetProjectBuildingTaxCredits?DevProjectBuildingId=' + devProjectBuildingId + '&SiteProjectBuildingId=' + siteProjBuildingId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    GetProjectBuildingTaxIncentives(devProjectBuildingId, siteProjBuildingId) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetProjectBuildingTaxIncentives?DevProjectBuildingId=' + devProjectBuildingId + '&SiteProjectBuildingId=' + siteProjBuildingId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    SaveProjectBuildingTaxIncentives(taxIncentive) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'SaveProjectBuildingTaxIncentives', taxIncentive, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    GetProjectBuildingResidentialMIHSuperUnits(devProjectBuildingId, siteProjBuildingId) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetProjectBuildingResidentialMIHSuperUnits?DevProjectBuildingId=' + devProjectBuildingId + '&SiteProjectBuildingId=' + siteProjBuildingId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    SaveProjectBuildingResidentialMIHSuperUnits(siteUnitCount) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'SaveProjectBuildingResidentialMIHSuperUnits', siteUnitCount, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    SaveCondoSturcture(condoStructure) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'SaveProjectBuildingCondoStructure', condoStructure, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    GetProjectBuildingCondoStructure(devProjectBuildingId, siteProjBuildingId) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetProjectBuildingCondoStructure?DevProjectBuildingId=' + devProjectBuildingId + '&SiteProjectBuildingId=' + siteProjBuildingId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    
    SaveProjectBuildingElectricSystems(electricSystem) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'SaveProjectBuildingElectricSystems', electricSystem, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    GetProjectBuildingElectricSystems(devProjectBuildingId, siteProjBuildingId) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetProjectBuildingElectricSystems?DevProjectBuildingId=' + devProjectBuildingId + '&SiteProjectBuildingId=' + siteProjBuildingId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    SaveProjectBuildingType(buildingType) {
        this.progressService.add();
        return this.http.post(this._baseUrl + 'SaveProjectBuildingType', buildingType, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    GetProjectBuildingType(devProjectBuildingId, siteProjBuildingId) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetProjectBuildingType?DevProjectBuildingId=' + devProjectBuildingId + '&SiteProjectBuildingId=' + siteProjBuildingId, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }

    getLookupsByGroupName(groupName) {
        this.progressService.add();
        return this.http.get(this._baseUrl + 'GetLookupsByGroupName?lookupGroupName=' + groupName, this.addHeader())
            .map((resp: Response) => resp.json())
            .catch(this.errorHandler)
            .finally(() => this.progressService.remove())
    }


}
